import React from "react"
import PropTypes from "prop-types"
import { Navigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { resolveAuthorizedRedirect } from "utils/accessibleRoutes"

/**
 * Redirects authenticated users away from routes they cannot access
 * (e.g. direct URL to a forbidden module) to their first allowed screen, or /forbidden.
 */
const RouteAccessGuard = ({ children }) => {
  const location = useLocation()
  const { userRole, accountType, accountScope, planSocialLogins } = useSelector(
    state => state.Login || {}
  )

  const ctx = { userRole, accountType, accountScope, planSocialLogins }
  const target = resolveAuthorizedRedirect(location.pathname, ctx)

  if (target !== location.pathname) {
    return (
      <Navigate
        to={target}
        replace
        state={{ accessDenied: true, from: location.pathname }}
      />
    )
  }

  return <>{children}</>
}

RouteAccessGuard.propTypes = {
  children: PropTypes.node.isRequired,
}

export default RouteAccessGuard
